import { render, staticRenderFns } from "./FoodServiceGroup.vue?vue&type=template&id=c90827ac&scoped=true&"
import script from "./FoodServiceGroup.vue?vue&type=script&lang=js&"
export * from "./FoodServiceGroup.vue?vue&type=script&lang=js&"
import style0 from "./FoodServiceGroup.vue?vue&type=style&index=0&id=c90827ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90827ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VCard,VCardText,VContainer,VDivider,VImg,VList,VListItem,VListItemAvatar,VListItemContent,VListItemTitle,VThemeProvider})
